import React, {FC, SyntheticEvent, JSX} from 'react';
import {NavItemInterface} from '../interfaces/nav-item.interface';
import { FlexContainer } from './flex-container';
import './nav-panel.scss';

interface Props {
    navItems: NavItemInterface[];
    onNavItemClick: Function;
    footer?: JSX.Element;
}

function buildTree(
    item: NavItemInterface, 
    depth: number, 
    onNavItemClick: Function,
) {
    return (
        <NavItemComponent
            key={item.name}
            name={item.name}
            childCount={item?.childNodes?.length || 0}
            depth={depth}
            path={item.path}
            onNavItemClick={onNavItemClick}
        >
            {item.childNodes && item.childNodes.map(child => {
                return buildTree(child, depth+1,  onNavItemClick);
            })}
        </NavItemComponent>
    )
}

export const NavPanel: FC<Props> = ({
    navItems,
    onNavItemClick,
    footer,
}) => {
       
    return (
        <div className="nav-panel">
            <FlexContainer
                orientation='column'
                vAlign='flex-start'
                hAlign='center'
            >
                <nav>
                { navItems.length && navItems.map(item => {
                    return buildTree(item, 1, onNavItemClick)
                })}
                </nav>
            </FlexContainer>
            {footer}
        </div>
    )
}

const NavItemComponent: FC<NavItemInterface> = ({
    name,
    onNavItemClick = () => {},
    path,
    depth,
    childCount,
    children,
}) => {

    const onItemClick = (e: React.SyntheticEvent, childCount: number)  => {
        if(e.target instanceof HTMLElement && childCount > 0){
            const div: HTMLElement | null = 
                e.target.parentElement!.querySelector('div.child-menu');
            if(div){
                if(div?.classList.contains('visible')){
                    div.style.height = `0px`;
                    div.classList.remove('visible');
                } else {
                    div.style.height = `${childCount*1.3}em`;
                    div?.classList.add('visible');
                }
            }
        }
        if(childCount > 0){

            return;
        }

        onNavItemClick(e, path);
    }

    const style={
        cursor: 'pointer',
    };

    const fontSize: number = 1.35/depth!;
    const margin: string = '0.2em 0';

    return (
        <FlexContainer 
            vAlign='top' 
            hAlign='center' 
            orientation='column'
            style={ depth! > 1 ? {margin} : {}}
            className='nav-item'
            onClick={(e) => onItemClick(e, childCount || 0)}
        >
            <span 
                className="nav-item-label"
                style={ depth! > 1 ? {fontSize: fontSize+'em'} : {}}
            >
                {name}
            </span>
            {children && 
                <div className='child-menu'>
                    {children}
                </div>
            }
        </FlexContainer>
    )
}
